var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"pa-0":"","ma-0":""}},[_c('v-autocomplete',{attrs:{"outlined":"","items":_vm.shownOfficeList,"return-object":"","item-text":"officeName","placeholder":"i.e. San Pedro","filter":_vm.filterList,"no-data-text":_vm.loadingText,"loading":_vm.currentlyLoading},on:{"change":_vm.onOfficeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }